import React from "react";
import FiltersContainer from "./FiltersContainer";
import { Container } from "react-bootstrap";

const RansomwareDropdownFilter = ({
  setCountrieFilter,
  setSectorFilter,
  setGroupFilter,
  countries,
  sectors,
  groups,
  dateOptions,
  handleChange,
}) => {
  return (
    <Container className={"my-4"} fluid>
      <div className="d-flex flex-column flex-md-row flex-wrap gap-2">
        <FiltersContainer setValue={handleChange} data={dateOptions} />
        <FiltersContainer
          setValue={setCountrieFilter}
          data={[
            { value: null, label: "All Countries" },
            ...countries
              ?.map((v) => ({
                value: v,
                label: v?.match(/[A-Z][a-z]+|[0-9]+/g)?.join(" "),
              }))
              .sort((a, b) => a.label?.localeCompare(b.label)),
          ]}
        />
        <FiltersContainer
          setValue={setSectorFilter}
          data={[
            { value: null, label: "All Sectors" },
            ...sectors
              ?.map((v) => ({
                value: v,
                label: v?.match(/[A-Z][a-z]+|[0-9]+/g)?.join(" "),
              }))
              .sort((a, b) => a.label?.localeCompare(b.label)),
          ]}
        />
        <FiltersContainer
          setValue={setGroupFilter}
          data={[
            { value: null, label: "All Groups" },
            ...groups
              ?.map((v) => ({
                value: v,
                label: v,
              }))
              .sort((a, b) => a.label?.localeCompare(b.label)),
          ]}
        />
      </div>
    </Container>
  );
};

export default RansomwareDropdownFilter;
